import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {forkJoin, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { BoilerService } from '../models/boiler-service/boiler-service';
import { BoilerServicePost } from '../models/boiler-service/boiler-service-post';
import { BoilerServiceOverview } from '../models/boiler-service/boiler-service-overview';
import { FileService } from "./file.service";
import { OwnerBoilerServiceOverview } from '../models/boiler-service/owner-boiler-service-overview';
import {PropertyServicesSummary} from "../models/property-services/property-services-summary.interface";
import {mergeMap, tap} from "rxjs/operators";
import {GasSafetyCertificatePost} from "../models/gas-safety-certificate/gas-safety-certificate-post";
import {GasSafetyCertificate} from "../models/gas-safety-certificate/gas-safety-certificate";
import {CustomCertificate} from "../models/custom-certificate/custom-certificate";


@Injectable()
export class BoilerServiceService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getOverview(propertyReference: string): Observable<BoilerServiceOverview> {
        return this.http.get<BoilerServiceOverview>(`${this.configService.baseUrl}/manage/property/${propertyReference}/boiler-service/overview`);
    }

    getList(propertyReference: string): Observable<BoilerService[]> {
        return this.http.get<BoilerService[]>(`${this.configService.baseUrl}/manage/property/${propertyReference}/boiler-service`);
    }

    getOwnerOverview(propertyReference: string): Observable<OwnerBoilerServiceOverview> {
        return this.http.get<OwnerBoilerServiceOverview>(`${this.configService.baseUrl}/owner/property/${propertyReference}/boiler-service/overview`);
    }

    getOwnerList(propertyReference: string): Observable<BoilerService[]> {
        return this.http.get<BoilerService[]>(`${this.configService.baseUrl}/owner/property/${propertyReference}/boiler-service`);
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<BoilerService>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/boiler-service/${guid}`);
    }

    add(organisationReference: string, model: BoilerServicePost): Observable<BoilerService> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<BoilerService>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/boiler-service`, model))
        );
    }

    remove(propertyReference: string, item: BoilerService): Observable<boolean> {
        return this.http.delete<boolean>(`${this.configService.baseUrl}/manage/property/${propertyReference}/boiler-service/${item.guid}`);
    }

    getOwnerBoilerService(propertyReference: string, guid: string): Observable<BoilerService> {
        return this.http.get<BoilerService>(`${this.configService.baseUrl}/owner/property/${propertyReference}/boiler-service/${guid}`);
    }

    getSummary(propertyReference: string) {
        const url = `${this.configService.baseUrl}/manage/property/${propertyReference}/boiler-service/summary`;
        return this.http.get<PropertyServicesSummary>(url);
    }
}
